import axios from 'axios';

const API_BASE = '/healthspan/api';

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('telogenis_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem('telogenis_token', token);
}

export function getToken() {
  return localStorage.getItem('telogenis_token');
}
